import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Rx';

import {SessionService} from '../services/session.service';
import {UserService} from "../services/user.service";
import {ConfigService} from "../../config/config.service";

@Injectable()
export class AuthorizationGuard implements CanActivate {
    isAdmin: boolean;

    constructor(private sessionService: SessionService,
                private router: Router,
                private userService: UserService,
                private configService: ConfigService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        this.sessionService.getUserType() === 'PORTAL' ? this.isAdmin = false : this.isAdmin = true;

        // alert(JSON.stringify(this.sessionService));

        // if(!this.isAdmin) {
        //     if((state.url.indexOf('member') > -1 && state.url.indexOf('reporting') === -1) || state.url.indexOf('offer') > -1 ||
        //         (state.url.indexOf('order') > -1 && state.url.indexOf('reporting') === -1) || state.url.indexOf('employ') > -1 || state.url.indexOf('product') > -1 ||
        //         state.url.indexOf('reporting-internal-orders') > -1 ) {
        //             // this.router.navigate(['/']);
        //             this.router.navigate(['http://localhost:4201']);
        //             return false;

        //         }
        // }
        if (this.sessionService.isAuthenticated()) {
            console.log('authenticated');
            return true;
        } else {
            if (this.sessionService.checkStorageSession() == null) {
                // console.log('null storage session');

                this.userService.userLogout()
                    .subscribe(
                        data => {
                            this.sessionService.destroySessionCookie(true);
                            window.open(this.configService.appURI, "_self");
                        },
                        error => {
                            this.sessionService.destroySessionCookie(true);
                            window.open(this.configService.appURI, "_self");
                        }
                    );
                // this.router.navigate([environment.appURI]); /// guard does not have from where to take refresh token and make call
                //this.router.navigate(['http://localhost:4201']); /// guard does not have from where to take refresh token and make call
                // window.open('http://localhost:4201', '_self');
            } else {
                return true;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/authorization.guard.ts